(function() {

    const baseUrl = 'https://stussy.com'

    const redirects = [
        {
            original: '/products/1904983-mercury-tee-whit-1?_kx=BPPsDtRizei9RqxjnnB2fNQ_YrFN4sZukHn9UiPMdDI%3D.NWFcCm&utm_medium=campaign&utm_source=Klaviyo',
            target: '/collections/tees/products/1904983-mercury-tee-white',
        },
        {
            original: '/products/1904983-mercury-tee-cora?_kx=BPPsDtRizei9RqxjnnB2fNQ_YrFN4sZukHn9UiPMdDI%3D.NWFcCm&utm_medium=campaign&utm_source=Klaviyo',
            target: '/collections/tees/products/1904983-mercury-tee-coral',
        },
        {
            original: '/products/1904965-kittens-tee-whit?_kx=BPPsDtRizei9RqxjnnB2fNQ_YrFN4sZukHn9UiPMdDI%3D.NWFcCm&utm_medium=campaign&utm_source=Klaviyo',
            target: '/collections/tees/products/1904965-kittens-tee-white',
        },
        {
            original: '/products/1904965-kittens-tee-blac?_kx=BPPsDtRizei9RqxjnnB2fNQ_YrFN4sZukHn9UiPMdDI%3D.NWFcCm&utm_medium=campaign&utm_source=Klaviyo',
            target: '/products/1904965-kittens-tee-black',
        },
        {
            original: '/products/1904962-orchard-tee-whit?_kx=BPPsDtRizei9RqxjnnB2fNQ_YrFN4sZukHn9UiPMdDI%3D.NWFcCm&utm_medium=campaign&utm_source=Klaviyo',
            target: '/collections/tees/products/1904962-orchard-tee-white',
        },
        {
            original: '/products/1904962-orchard-tee-cora?_kx=BPPsDtRizei9RqxjnnB2fNQ_YrFN4sZukHn9UiPMdDI%3D.NWFcCm&utm_medium=campaign&utm_source=Klaviyo',
            target: '/products/1904962-orchard-tee-coral',
        }
    ]

    redirects.forEach((redirect) => {
        if(window.location.href.includes(redirect.original)) window.location.replace(baseUrl + redirect.target)
    })

})();